import { delay, map } from 'rxjs/operators';
import { inject, injectable } from 'inversify';
import { INotificationMutationService, NotificationMutationObservable } from '../../../interfaces';
import { INotificationsService, NOTIFICATIONS_SERVICE } from '../notifications';
import { transactionToNewUpdate } from './notification-mutation-new.service.utils';
import { UNSET_NEW_NOTIFICATION_DELAY } from '../../../helpers';

@injectable()
export class NotificationMutationNewService implements INotificationMutationService {

    @inject(NOTIFICATIONS_SERVICE) private readonly notificationsService: INotificationsService;

    mutations(): NotificationMutationObservable {
        return this.notificationsService.notificationTransactionsObservable().pipe(
            delay(UNSET_NEW_NOTIFICATION_DELAY),
            map(transactionToNewUpdate),
        );
    }
}
